import store from '@/store';
const AdminRequestsIndex = () => import(/* webpackChunkName: "admin-module" */ '@views/admin/requests/index.vue');
const AdminRequests = () => import(/* webpackChunkName: "admin-module" */ '@views/admin/requests/views/RequestList.vue');
const AdminRequest = () => import(/* webpackChunkName: "admin-module" */ '@views/admin/requests/views/ClientRequest.vue');

export default [
    {
        path: '/admin/requests',
        components: { base: AdminRequestsIndex },
        beforeEnter: (to, from, next) => {
            if (store.getters.canAccessAdminRequestsIndex) {
                next();
            } else {
                next({ path: '/access-restricted' });
            }
        },
        children: [
            {
                path: '',
                name: 'admin.requests',
                components: { 'admin-requests': AdminRequests }
            },
            {
                path: ':id',
                name: 'admin.request',
                components: { 'admin-requests': AdminRequest }
            }
        ]
    }
];
